import React from 'react';
import "antd/dist/antd.css";
import { Requests } from './components/Requests';

function App() {
  return (
    <div className="App">
      <Requests />
    </div>
  );
}

export default App;
